// Prerender everything - this is a static-feeling SPA.
export const prerender = true;
export const ssr = false;
